import {useSnackbar} from 'notistack';
import {Box, Grid, Stack, Typography} from '@mui/material';
import {Colors} from '@constants/colors.constants';
import InfosCard from '@components/cards/infos/Infos.card';
import React, {useEffect, useState} from 'react';
import {changeRateService} from '@store/settings/changeRate/change-rate.service';
import dayjs from 'dayjs';
import {ChangeRatePeriod} from '@store/settings/changeRate';
import {List} from '@mui/icons-material';
import ChangeRateListModal from '@screens/admin/settings/changeRate/changeRateListModal/ChangeRateList.modal';
import {useTranslation} from 'react-i18next';

const ChangeRateTab = () => {
  const {enqueueSnackbar} = useSnackbar();
  const {t} = useTranslation();

  const [selectedPeriod, setSelectedPeriod] = useState<Date | undefined>(undefined);
  const [changePeriods, setChangePeriods] = useState<ChangeRatePeriod[]>([]);

  useEffect(() => {
    changeRateService.getRatePeriods().subscribe({
      next: setChangePeriods,
      error: (err) => enqueueSnackbar(err.text, err.options),
    });
  }, [enqueueSnackbar]);

  return (
    <>
      <Stack flex={1} width="100%" spacing={2} p="25px">
        <Typography fontSize="30px" fontWeight="700">
          {t('routes.change-rate')}
        </Typography>
        <Box flex={1} pt="25px" overflow="hidden">
          <Stack height="100%" overflow="hidden" borderRadius="4px" bgcolor={Colors.white}>
            <Stack p="30px" overflow="auto" className="scrollable">
              <Grid container spacing={2} columns={6}>
                {changePeriods?.map((cr) => (
                  <Grid item key={new Date(cr.periodStart).toDateString()} xs={1}>
                    <InfosCard
                      menuOptions={<List/>}
                      title={dayjs(cr.periodStart).format('MMMM').toUpperCase()}
                      unit={dayjs(cr.periodStart).format('YYYY')}
                      onClick={() => setSelectedPeriod(new Date(cr.periodStart))}
                    />
                  </Grid>
                ))}
              </Grid>
            </Stack>
          </Stack>
        </Box>
      </Stack>
      {selectedPeriod &&
          <ChangeRateListModal periodStart={selectedPeriod} handleClose={() => setSelectedPeriod(undefined)}/>}
    </>
  );
};

export default ChangeRateTab;
